import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Collections, Parts, Types} from "components";
import UserRoles from "constants/UserRoles";
import {CirclePicker} from 'react-color'
import {Alert, Button, ButtonGroup, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import moment from "moment"
import API from "@beardeddevops/react.api";
import FormControl from "@material-ui/core/FormControl/FormControl";
import InputLabel from "@material-ui/core/InputLabel/InputLabel";
import TextField from "@material-ui/core/TextField";
import Select from "react-select";
import 'react-confirm-alert/src/react-confirm-alert.css';
import {
	ensureNonHiringRegionAcknowledged,
	fetchHiringRegions,
	getRegionMeta,
	getRegionName,
	isRegionHiring,
	showNonHiringRegionAlert,
} from "components/utils/hiringRegions";

/**
 *  @property {Hiring_Candidate_Object} state
 *  @property {object} model
 *  @property {Hiring_Candidate_Properties} model.properties
 *  @property {Hiring_Candidate_Is} model.is
 *  @property {Hiring_Candidate_Has} model.has
 */
export default class Candidate extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Hiring_Candidate._name);
		this.state.candidate_status = 2;
		this.state.new_note = '';
		this.state.showDuplicateModal = false;
		this.state.skipValidation = false;
		this.state.user_created = false;
		this.state.hiringRegions = [];
		this.state.hiringRegionAcknowledged = false;
		this.state.hiringSaveConfirmed = false;
		this._lastRegionPkey = undefined;
		this.hiringAlertOpen = false;
	}

	async componentDidMount() {
		super.componentDidMount();
		if (typeof (this.props.cacheInfo) === 'function') {
			if (this.props.cachedInfo) {
				this.setState(this.props.cachedInfo)
			}
		}
		this.getHiringRegions();
	};

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		if (prevProps.id !== this.props.id) {
			this._lastRegionPkey = undefined;
			this.hiringAlertOpen = false;
			this.setState({
				hiringRegionAcknowledged: false,
				hiringSaveConfirmed: false,
			});
			this.getHiringRegions();
			return;
		}

		if (
			prevState.region !== this.state.region &&
			this.state.hiringRegions.length > 0 &&
			typeof this.state.region !== 'undefined'
		) {
			this.onRegionChanged(this.state.region);
		}
	}

	getHiringRegions = async () => {
		try {
			const regions = await fetchHiringRegions();
			this.setState({hiringRegions: regions}, () => {
				if (this.state.region) {
					this._lastRegionPkey = undefined;
					this.onRegionChanged(this.state.region);
				}
			});
		} catch (error) {
		}
	}

	getRegionMeta = (regionPkey) => {
		return getRegionMeta(regionPkey, this.state.hiringRegions);
	}

	getRegionName = (regionPkey) => {
		return getRegionName(regionPkey, this.state.hiringRegions, this.state.regions);
	}

	isRegionHiring = (regionPkey) => {
		return isRegionHiring(regionPkey, this.state.hiringRegions, this.state.regions);
	}

	showNonHiringRegionAlert = ({context, regionName}) => {
		return showNonHiringRegionAlert({context, regionName});
	}

	onRegionChanged = async (regionPkey) => {
		if (!this.state.hiringRegions.length) {
			return;
		}

		const prevRegion = this._lastRegionPkey;
		this._lastRegionPkey = regionPkey;

		if (prevRegion === regionPkey) {
			return;
		}

		this.setState({hiringRegionAcknowledged: false, hiringSaveConfirmed: false});

		if (!regionPkey || this.isRegionHiring(regionPkey)) {
			return;
		}

		if (this.hiringAlertOpen) {
			return;
		}

		this.hiringAlertOpen = true;
		const acknowledged = await this.showNonHiringRegionAlert({
			context: 'region',
			regionName: this.getRegionName(regionPkey)
		});
		this.hiringAlertOpen = false;

		if (acknowledged) {
			this.setState({hiringRegionAcknowledged: true});
		}
	}

	handleRegionPropertyUpdate = (property, value, linked, object) => {
		this.handleSelectPropertyUpdate(property, value, linked, object);
		if (property?.name === 'region') {
			this.onRegionChanged(value);
		}
	}

	handleStatusPropertyUpdate = (property, value, linked, object) => {
		this.handleSelectPropertyUpdate(property, value, linked, object);
		// Soft prompt: when moving a candidate to Scheduled Interview (status 4),
		// default the interview date to now if one hasn't been set yet. Does not block saving.
		if (value === 4 && !this.state.interview_date) {
			this.setState({interview_date: moment().format('YYYY-MM-DD HH:mm:ss')});
		}
	}

	loadSelfAfterAlways() {
		if (this.state.next_pkey && typeof(this.props.render_next_button) === 'function') {
			this.props.render_next_button(this.state.next_pkey)
		}
		if (this.state.pkey && typeof(this.props.show_user_create_button) === 'function') {
			this.props.show_user_create_button(this.state.candidate_status === 12)
		}
		if (this.state.pkey && typeof(this.props.set_already_exists) === 'function') {
			this.props.set_already_exists(this.state.user_created)
		}
		if (this.state.pkey && typeof(this.props.update_base_pay) === 'function') {
			this.props.update_base_pay(this.state.base_pay);
		}
		if (this.state.pkey && typeof(this.props.update_email) === 'function') {
			this.props.update_email(this.state.email)
		}
	};

	updateAddress = (address) => {
		this.setState({street_1: address.setStreet, city: address.city, state: address.state, zip: address.zip})
	}
	validateAddress = (lat, lng) => {
		this.setState({latitude: lat, longitude: lng})
		if (typeof (this.props.cacheInfo) === 'function') {
			this.props.cacheInfo(this.state, this.props);
		}
	}

	setRegion = (region) => {
		if (region === null) {
			alert('This candidate has no region!')
		}
		this.setState({region}, () => this.onRegionChanged(region))
	}

	ensureHiringWarningsForSave = async () => {
		return ensureNonHiringRegionAcknowledged({
			regionPkey: this.state.region,
			hiringRegions: this.state.hiringRegions,
			regionObject: this.state.regions,
			context: 'save',
			requireRegionAck: !this.state.hiringRegionAcknowledged,
		}).then((confirmed) => {
			if (confirmed && !this.isRegionHiring(this.state.region)) {
				this.setState({hiringRegionAcknowledged: true, hiringSaveConfirmed: true});
			}
			return confirmed;
		});
	}

	handleSubmit = async (event) => {
		this.setState({hiringSaveConfirmed: false});

		const canSave = await this.ensureHiringWarningsForSave();
		if (!canSave) {
			return;
		}

		if (this.state.pkey) {
			await super.handleSubmit(event, false, false)
			this.setState({new_note: ''});
			await this.loadSelf();
		} else {
			//run validate call to api to check last name, email, and phone. if it returns any duplicates then pop the modal and force them to "save"
			let candidateModel = new API.BuildClass(Types.Hiring_Candidate._name, API.RequestType.CREATE);
			candidateModel.object = this.state;
			const possibleDuplicates = await candidateModel.submit(null, "PUT_VALIDATE", true);
			if (possibleDuplicates.length > 0 && this.state.skipValidation === false) {
				this.setState({possibleDuplicates, showDuplicateModal: true})
			} else {
				await super.handleSubmit(event, false, false)
				this.setState({new_note: ''});
				await this.loadSelf();
			}
		}
	}

	form = () => {

		/**
		 * @param {Hiring_Candidate_Properties} data
		 */
		let {properties} = this.model
		/**
		 * @type {Hiring_Candidate_Object} object
		 */
		let object = this.state
		let {loading} = this.state

		const copyableValue = (((this.state.name_first?.length === 0 || !this.state.name_first ? "N/A" : this.state.name_first) + ' ' + (this.state.name_last?.length === 0 || !this.state.name_last ? "N/A" : this.state.name_last)) + "\r" +
			((this.state.street_1?.length === 0 || !this.state.street_1 ? "N/A" : this.state.street_1) + ", " + (this.state.city?.length === 0 || !this.state.city ? "N/A" : this.state.city) + ", "
				+ (this.state.state?.length === 0 || !this.state.state ? "N/A" : this.state.state) + " " + (this.state.zip?.length === 0 || !this.state.zip ? "N/A" : this.state.zip)) + "\r"
			+ (this.state.phone?.length === 0 || !this.state.phone ? "N/A" : this.state.phone) + "\r" + (this.state.email?.length === 0 || !this.state.email ? "N/A" : this.state.email) + "\r"
			+ ((this.state.base_pay?.length === 0 || !this.state.base_pay ? "N/A" : this.state.base_pay) + " / " + (this.state.start_date?.length === 0 || !this.state.start_date ? "N/A" : moment(this.state.start_date).format("YYYY-MM-DD"))))

		const showNonHiringBanner = !!object.region && !this.isRegionHiring(object.region);
		const nonHiringRegionName = showNonHiringBanner ? this.getRegionName(object.region) : '';

		return (
			<div>
				{showNonHiringBanner &&
					<Alert color="danger">
						<p style={{fontSize: '18px', marginBottom: 0}}>
							<strong>This service region is not currently hiring.</strong>
							{' '}({nonHiringRegionName})
						</p>
					</Alert>
				}
				<fieldset>
					<div className={"row"}>
						<div className={"col-md"}>
							<div className={'section-title'}>
								<h4 className="section-title">Basic Information</h4>
								<div className={'flex-end text-right'}>
									<Button color="info" onClick={() => {
										this.setState({infoModal: true})
									}}>
										Hiring Info
									</Button>
								</div>
							</div>
							<div className={'row'}>
								<div className={'col-6'}>
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.name_first}
											value={object.name_first}
											error={object.name_first_error}
											update={this.handleTextFieldPropertyUpdate}
											label={'First Name'}
										/>
									</div>
								</div>
								<div className={'col-6'}>
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.name_last}
											value={object.name_last}
											error={object.name_last_error}
											update={this.handleTextFieldPropertyUpdate}
											label={'Last Name'}
										/>
									</div>
								</div>
							</div>
							<div className={'row'}>
								<div className={'col-6'}>
									<div className="form-group">
										<Framework.Elements.PhoneNumber
											property={properties.phone}
											value={object.phone}
											error={object.phone_error}
											update={this.handleTextFieldPropertyUpdate}
											label={'Phone'}
										/>
									</div>
								</div>
								<div className={'col-6'}>
									<div className="form-group">
										<Framework.Elements.EmailAddress
											property={properties.email}
											value={object.email}
											error={object.email_error}
											update={this.handleTextFieldPropertyUpdate}
											label={'Email Address'}
											type={'email'}
										/>
									</div>
								</div>
							</div>

							<div className={'row'}>
								<div className={'col-6'}>
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.resume}
											value={object.resume}
											error={object.resume_error}
											update={this.handleTextFieldPropertyUpdate}
											label={'Resume Link'}
										/>
									</div>
								</div>
								<div className={'col-6'}>
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.salary}
											value={object.salary}
											error={object.salary_error}
											update={this.handleTextFieldPropertyUpdate}
											label={'Candidate Expected Salary'}
										/>
									</div>
								</div>
							</div>

							<div className={'row'}>
								<div className={'col-12'}>
									<h4 className="section-title">Address</h4>
									<Parts.Address object={{...this.state}} properties={properties} parent={this} updateAddress={this.updateAddress}
									               validateAddress={this.validateAddress} setRegion={this.setRegion}/>
								</div>
							</div>
							<div className={'row'}>
								<div className={'col-6'}>
									<h4 className="section-title">Candidate Status</h4>
									<div className="form-group">
										<Framework.Elements.Select
											shouldLoad={this.state.loaded}
											property={properties.candidate_status}
											value={object.candidate_status}
											error={object.candidate_status_error}
											model={Types.Candidate_Statuses._name}
											update={this.handleStatusPropertyUpdate}
											label={"Candidate Status"}
											nullable={true}
										/>
									</div>
								</div>
								<div className={'col-6'}>
									<h4 className="section-title">Service Region</h4>
									<div className="form-group">
										<Framework.Elements.Select
											shouldLoad={this.state.loaded}
											property={properties.region}
											value={object.region}
											error={object.region_error}
											object={object.regions}
											update={this.handleRegionPropertyUpdate}
											nullable={true}
										/>
									</div>
								</div>
							</div>

							{/*<div className={'col-4'}>*/}
							{/*	<div className="form-group">*/}
							{/*		<Framework.Elements.TextField*/}
							{/*			property={properties.latitude}*/}
							{/*			value={object.latitude}*/}
							{/*			error={object.latitude_error}*/}
							{/*			update={this.handleTextFieldPropertyUpdate}*/}
							{/*			label={'Latitude'}*/}
							{/*		/>*/}
							{/*	</div>*/}
							{/*</div>*/}
							{/*<div className={'col-4'}>*/}
							{/*	<div className="form-group">*/}
							{/*		<Framework.Elements.TextField*/}
							{/*			property={properties.longitude}*/}
							{/*			value={object.longitude}*/}
							{/*			error={object.longitude_error}*/}
							{/*			update={this.handleTextFieldPropertyUpdate}*/}
							{/*			label={'Longitude'}*/}
							{/*		/>*/}
							{/*	</div>*/}
							{/*</div>*/}
						</div>

						<div className={"col-md"}>
							<h4 className="section-title">Hiring Notes</h4>
							<div className={'row'}>
								<div className={'col-3'}>
									<div className="form-group">
										<FormControl fullWidth={true} variant={'outlined'} size="large" style={{position: 'relative'}}>
											{!!this.state.rating && <InputLabel style={{
												backgroundColor: "#FFFFFF",
												paddingLeft: 5,
												paddingRight: 5,
												zIndex: 1,
											}} shrink={!!this.state.rating}>Rating (1–10)</InputLabel>}
										<Select
											placeholder={"Rating (1-10)"}
											isMulti={false}
											isClearable={false}
											value={
												this.state.rating
													? { label: this.state.rating.toString(), value: this.state.rating }
													: null
											}
											onChange={(option) => this.setState({ rating: option.value })}
											options={Array.from({ length: 10 }, (_, i) => ({
												label: (10 - i).toString(),
												value: 10 - i,
											}))}
											styles={{
												control: (base, state) => ({
													...base,
													minHeight: 40,
													borderColor: state.isFocused ? "#1976d2" : "#ccc",
													boxShadow: state.isFocused ? "0 0 0 1px #1976d2" : "none",
													"&:hover": {
														borderColor: state.isFocused ? "#1976d2" : "#888",
													},
												}),
												menuPortal: (base) => ({ ...base, zIndex: 9999 }),
											}}
											menuPortalTarget={document.body}
										/>
										</FormControl>
									</div>
								</div>
								<div className={'col-3'}>
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.base_pay}
											value={object.base_pay}
											error={object.base_pay_error}
											update={this.handleTextFieldPropertyUpdate}
											label={'Base Pay'}
										/>
									</div>
								</div>
								<div className={'col-3'}>
									<div className="form-group">
										<Framework.Elements.DateTime
											label="Start Date"
											property={properties.start_date}
											value={object.start_date}
											error={object.start_date_error}
											update={this.handleTextFieldPropertyUpdate}
											format={'ddd M/D/YY'}
											mask={'___ _/_/__'}
										/>
									</div>
								</div>
								<div className={'col-3'}>
									<div className="form-group">
										<Framework.Elements.DateTime
											label="Interview Date"
											property={properties.interview_date}
											value={object.interview_date}
											error={object.interview_date_error}
											update={this.handleTextFieldPropertyUpdate}
											format={'ddd M/D/YY h:mm A'}
										/>
									</div>
								</div>
							</div>
							<div className={'row'}>
								<div className={'col-12'}>
									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.notes}
											value={object.notes}
											error={object.notes_error}
											update={this.handleTextFieldPropertyUpdate}
											label={'Candidate Notes'}
											multiline={14}
											disabled={true}
										/>
									</div>
								</div>
							</div>
							<div className={'row'}>
								<div className={'col-12'}>
									<TextField
										label={'Add Note...'}
										value={this.state.new_note}
										onChange={(event) => this.setState({new_note: event.currentTarget.value})}
										fullWidth={true}
										multiline={true}
										rows={5}
										margin="dense"
										variant="outlined"
									/>
								</div>
							</div>
						</div>
					</div>
				</fieldset>

				<Modal
					isOpen={this.state.showDuplicateModal}
					toggle={() => {
						this.setState({showDuplicateModal: false})
					}}
					size={"lg"}
					backdrop={true}
					style={{opacity: 1}}
				>
					<ModalHeader>
						Possible Duplicates
					</ModalHeader>
					<ModalBody>
						<Collections.Candidates
							filter={{}}
							tableData={this.state.possibleDuplicates}
						/>
					</ModalBody>
					<ModalFooter>
						<Button color="secondary" onClick={() => {this.setState({showDuplicateModal: false, skipValidation: false})}}>Close</Button>
						<Button color="primary" onClick={async (event) => {
							this.setState({showDuplicateModal: false, skipValidation: true})
							await this.handleSubmit(event);
						}}>Not a Duplicate</Button>
					</ModalFooter>
				</Modal>

				<Modal
					isOpen={this.state.infoModal}
					toggle={() => {
						this.setState({infoModal: false})
					}}
					size={"md"}
					backdrop={true}
					style={{opacity: 1}}
				>
					<ModalHeader>
						Hiring Copyable Info
					</ModalHeader>
					<ModalBody>
						<div className="form-group">
							<div className={'row'}>
								<div className={'col-12'}>
									<TextField
										label={'Copyable'}
										value={copyableValue}
										fullWidth={true}
										multiline={true}
										rows={5}
										margin="dense"
										variant="outlined"
										disabled={true}
										// onClick={() => {
										// 	navigator.clipboard.writeText(copyableValue)
										// 	API.Toast.info('Copied!', {
										// 		position: API.Toast.POSITION.TOP_CENTER
										// 	});
										// }}
									/>
								</div>
							</div>
						</div>
					</ModalBody>
					<ModalFooter>
						<Button color="primary" onClick={() => {navigator.clipboard.writeText(copyableValue)
							API.Toast.info('Copied!', {
								position: API.Toast.POSITION.TOP_CENTER
							});
						}}>Copy</Button>
						<Button color="secondary" onClick={() => {this.setState({infoModal: false})}}>Close</Button>
					</ModalFooter>
				</Modal>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}
}
